module.exports = __webpack_public_path__ + "img/ic-chev-e-2.a75ed6f4.svg";